type TourMap = Record<string, string>;

function getTourVideoMapFromEnv(): TourMap {
  try {
    const raw = process.env.REACT_APP_TOUR_VIDEO_MAP || '{}';
    const parsed = JSON.parse(raw);
    return parsed;
  } catch (err) {
    //console.error("Invalid REACT_APP_TOUR_VIDEO_MAP:", err);
    return {};
  }
}

export const boardingTourMap: TourMap = getTourVideoMapFromEnv();
